import * as React from 'react';
import './ResultsCounter.scss';
import i18n from 'src/translation/i18n';

interface IResultsCounter {
  resultsQuantity: number;
  item: string;
  clearFilters: () => void;
  error?: any;
  targetSearchField?: string;
}

const ResultsCounter: React.FC<IResultsCounter> = props => {
  const { resultsQuantity, item, clearFilters } = props;

  const handleClearFilters = (e: any) => {
    e.preventDefault();
    clearFilters();
  };

  return props.targetSearchField === 'invoiceNumber' &&
    props.error?.hasError &&
    props.error?.status === 400 ? (
    <div className="rp-results-counter">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex flex-column flex-md-row justify-content-between">
            <p>
              <span className="rp-results-counter-values">
                {props.error?.message}
              </span>
            </p>
            <a
              href="#"
              onClick={handleClearFilters}
              className="rp-results-counter-clear"
            >
              {i18n.t('common.clearFilters')}
            </a>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="rp-results-counter">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex flex-column flex-md-row justify-content-between">
            <p>
              <span className="rp-results-counter-values">
                {resultsQuantity}
              </span>{' '}
              {i18n.t('common.search')} {i18n.t('common.results')}{' '}
              {i18n.t('common.for')}{' '}
              <span className="rp-results-counter-values">{item}</span>
            </p>
            <a
              href="#"
              onClick={handleClearFilters}
              className="rp-results-counter-clear"
            >
              {i18n.t('common.clearFilters')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultsCounter;
